import { map, identity, isArray, isPlainObject, reduce, camelCase, snakeCase, } from 'lodash';
export function transformObjectKeys(obj, trasformer = identity) {
    if (isArray(obj)) {
        return map(obj, (val) => transformObjectKeys(val, trasformer));
    }
    if (isPlainObject(obj)) {
        return reduce(obj, (acc, value, key) => {
            acc[trasformer(key)] = transformObjectKeys(value, trasformer);
            return acc;
        }, {});
    }
    return obj;
}
export function keysToCamelCase(obj) {
    return transformObjectKeys(obj, camelCase);
}
export function keysToSnakeCase(obj) {
    return transformObjectKeys(obj, snakeCase);
}
export function removeUndefinedValues(obj) {
    return Object.entries(obj).reduce((acc, [key, val]) => val === undefined
        ? acc
        : {
            ...acc,
            [key]: val,
        }, {});
}
//# sourceMappingURL=object.js.map